import { z } from "zod";
import {
  Countries,
  countryEnumToNumber,
  countryNumToEnum,
  Languages,
} from "./enums";

//? DTO
export const personDtoSchema = z.object({
  Id: z.number(),
  Name: z.string().nullish(),
  Email: z.string(),
  Phone: z.string().nullish(),
  Birthdate: z.string().nullish(),
  Language: z.string().nullish(),
  Country: z.number().nullish(),
});

export type PersonDto = z.infer<typeof personDtoSchema>;

export const createPersonDtoSchema = personDtoSchema.omit({ Id: true });
export type CreatePersonDto = z.infer<typeof createPersonDtoSchema>;

//? Model

export const PersonSchema = z.object({
  name: z.string().min(1),
  email: z.string().email(),
  phone: z.string().nullish(),
  country: z
    .string()
    .nullish()
    .refine((val) => {
      if (val === null || val === undefined) return true;
      return Countries.includes(val);
    }),
  birthdate: z.string().nullish(),
  language: z.array(z.enum(Languages)).nullish(),
});
export type Person = z.infer<typeof PersonSchema>;

//? Mappers

export function personToDto(person: Person): CreatePersonDto {
  return {
    Name: person.name,
    Birthdate: person.birthdate,
    Email: person.email,
    Language: person.language?.join(" | "),
    Phone: person.phone,
    Country:
      person.country === null || person.country === undefined
        ? null
        : countryEnumToNumber[person.country],
  };
}

export function personFromDto(dto: CreatePersonDto): Person {
  return {
    name: dto.Name ?? "",
    email: dto.Email,
    phone: dto.Phone,
    birthdate: dto.Birthdate,
    country:
      typeof dto.Country !== "number"
        ? null
        : countryNumToEnum[dto.Country.toString()],
    language: dto.Language?.split(" | ").filter(Boolean) as Array<
      (typeof Languages)[number]
    >,
  };
}
